const FaqsData = [
  {
    id: 1,
    question: "How many Videos Can i produce per month ?",
    answer1:
      "The number of videos you can complete in the course of a month depends on certain factors, including their complexity as well as your decision to request additional rounds of revision.",
    answer2:
      "Conservatively speaking, our clients get 4 to 6 video projects completed per month on average.",
    answer3:
      "If your videos are particularly complex or need a lot of editing, this will affect how many videos we can produce for you.",
    answer4:
      "Once your editor gets a feel for your style and you grow trust in their creative judgment, the amount you can produce each month can increase.",
  },
  {
    id: 2,
    question: "What type of videos and editing do you do ?",
    answer1:
      "Apart from Wedding Videos, Animations, and Recording Voice Overs, we can do any type of video editing for you!",
  },
  {
    id: 3,
    question: "How fast is the turnaround ?",
    answer1:
      "You'll often get your first draft within 1-2 business days. Unless your videos are particularly long or complex and in those cases, we’ll inform you why the turnaround might be longer.",
    answer2: "Revisions almost always take just 1 day.",
    answer3:
      "You could get multiple videos edited at the same time if you work with more than one editor.",
  },
  {
    id: 4,
    question: "Can I work with more than one editor ?",
    answer1:
      "If you'd like a number of videos worked on simultaneously by multiple editors, then you can purchase an additional account. Simply tell one of our sales reps and they’ll set you up during your demo call.",
  },
  {
    id: 5,
    question: "How can I contact you ?",
    answer1:
      "If you have any questions about becoming a customer, the best way to get the answers you're looking for is via our on-site chat icon.",
    answer2:
      "When you join Video Husky, your account manager will be your main point of contact and will look after all of your projects.",
    answer3:
      "If you need help with your account, for example updating your card details, then just shoot us an email at success@videohusky.com.",
  },
  {
    id: 6,
    question: "Are your editors in-house of freelance ?",
    answer1:
      "All of our editors are in-house professionals who are regularly assessed for quality and efficiency. As part of the hiring process, they go through a rigorous bootcamp where their creative and editing skills are tested.",
  },
  {
    id: 7,
    question: "How does the 'unlimited' offer work ?",
    answer1:
      "On the Eskimo Plan, revisions are unlimited so you can request as many as you’d like. The Pom plan, meanwhile, has a limit of 3 revisions per project.",
    answer2:
      "On both plans, you can submit as many video requests as you’d like. But it’s important to note that we work on one video at a time.",
    answer3:
      "You can queue as many video projects as you like and as soon as we’ve completed one project for you, we’ll get started on the next one right away.",
    answer4:
      "If you’d like multiple videos worked on simultaneously, then you can purchase an additional editing team on retainer. You can get a 10% discount by adding a secondary account on a quarterly basis.",
  },
  {
    id: 8,
    question: "What video editing software do you use ?",
    answer1:
      "We use Adobe Premiere Pro. We also can provide you with the Premiere Project file if you prefer to add some finishing touches to your videos on your side.",
  },
  {
    id: 9,
    question: "Do you work with 4K ?",
    answer1:
      "At the moment, we can only render final videos in 1080p. If you've filmed 4k footage, we can edit it if you can provide us with proxy files.",
    answer2:
      "Most of our customers submit proxy files so it’s easier to upload, download, and to work with their editor. In those cases, we can also submit the Premiere Project Files back to you so you can link all the final videos.",
  },
  {
    id: 10,
    question: "Can we have multiple exports out from one main source video?",
    answer1:
      "Yes, we can definitely do that! Most customers have this request.",
    answer2:
      "You can request one main export (formatted in 16:9 aspect ratio for widescreen viewing) and depending on the plan up to 3 to 5 additional bonus exports. Review our pricing page to see how many exports you can get per plan.",
  },
  {
    id: 11,
    question: "Is there a limit on the raw files I can submit",
    answer1:
      "For the Pom Plan, we can accept a maximum of 20GB of raw footage and assets per project. For the Eskimo Plan, we can accept a maximum of 40GB.",
  },
];

export default FaqsData;
